module.exports = __webpack_public_path__ + "public/images/slider/slide-1.d7ffe0a290067847d0a3856019cadcdb.jpg";